// "Colic Coverage" tab.
//
// The Colic Surgery Coverage program is live (memory:
// project_100x_equine_colic_enrollment). Terms: 30-day qualifying window,
// $20K lifetime cap, notify 14 days from surgery, forms 14 days from
// discharge (memory: reference_100x_equine_colic_program_terms).
import type { ReactNode } from 'react';
import { TabPlaceholder } from './TabPlaceholder.js';

export function ColicCoverage(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Colic Coverage"
      wiringNotes="Shows enrollment status, qualifying purchase timeline, and the reimbursement claim flow. Enrollment write goes through the HubSpot workflow; claim status reads from services/customer-coverage."
    />
  );
}
